import React from 'react'
import {useEffect} from 'react'
import {useParams} from 'react-router-dom'
import UseVerify from '../hooks/useVerify'
import {Link} from 'react-router-dom'
function Verification() {
  const {key} = useParams()
  const { data, send } = key ? UseVerify({ key }) : { data: '', send: () => {} };
    
    useEffect(() => {
     
    send()
    
    },[key])
  return (
    <div className='verification'>
     <h4>Your email is verified, you can <Link to='/login'>Login</Link></h4> 
    </div>
  )
}

export default Verification
